import React from 'react'

import OutsideWallModel from './OutsideWallModel';
import InsideWallModel from './InsideWallModel';

const FrontStorage = () => {

    return (
        <>
            <OutsideWallModel />
            <InsideWallModel />
        </>
    )
}

export default FrontStorage